/**
 * Waits minimumMs milliseconds plus a randomly chosen value in the range of rangeMs milliseconds.
 */
export function waitRandom(minimumMs: number, rangeMs: number): Promise<void> {
  if (minimumMs < 0) {
    return Promise.reject(new Error('minimumMs less than 0 is invalid. Got: ' + minimumMs));
  }
  if (rangeMs < 0) {
    return Promise.reject(new Error('Range less than 0 is invalid.Got: ' + rangeMs));
  }
  return new Promise((resolve) => {
    setTimeout(resolve, minimumMs + rangeMs * Math.random());
  });
}

export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
